import React from "react";
import { ShoppingBag, RotateCcw, UserPlus, PieChart, ArrowRight } from "lucide-react";

export default function Dashboard1() {
  const stats = [
    {
      count: 5,
      label: "Orders",
      color: "bg-cyan-600",
      icon: <ShoppingBag size={48} className="opacity-40" />,
    },
    {
      count: 0,
      label: "Pending return requests",
      color: "bg-yellow-500",
      icon: <RotateCcw size={48} className="opacity-40" />,
    },
    {
      count: 6,
      label: "Registered customers",
      color: "bg-green-600",
      icon: <UserPlus size={48} className="opacity-40" />,
    },
    {
      count: 1,
      label: "Low stock products",
      color: "bg-red-600",
      icon: <PieChart size={48} className="opacity-40" />,
    },
  ];

  return (
    <div className="bg-white rounded-md shadow border">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b">
        <div className="flex items-center gap-2 text-gray-700 font-semibold">
          <PieChart size={18} className="text-gray-600" />
          Common statistics
        </div>
        <button className="text-gray-400 hover:text-gray-600 text-xl font-bold">
          –
        </button>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
        {stats.map((item, index) => (
          <div
            key={index}
            className={`${item.color} text-white rounded-md shadow-md flex flex-col justify-between`}
          >
            <div className="flex justify-between items-center p-4">
              <div>
                <h2 className="text-3xl font-bold">{item.count}</h2>
                <p className="text-sm font-medium mt-1">{item.label}</p>
              </div>
              <div>{item.icon}</div>
            </div>
            <div className="bg-black/10 text-center py-2 text-sm font-medium flex items-center justify-center gap-1 hover:bg-black/20 cursor-pointer transition">
              More info <ArrowRight size={16} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
